import { PDF_BORDER, ReportPage, ReportTable, Text } from '@/components';
import { ReportBatchTargetLabelModifier } from '@/features/mold/models';
import type { OrganizingTableFormat5Props } from '@/features/mold/utils/pdf/pdf-components-props';
import { useLocaledAmount } from '@/providers';
import type { FC } from 'react';

export const OrganizingTableFormat5: FC<OrganizingTableFormat5Props> = ({
  header,
  body,
  footer,
  organizationNames,
  dateByCreated,
  paperSize,
}) => {
  const { unit } = useLocaledAmount();
  return (
    <ReportPage
      title={{
        text: ReportBatchTargetLabelModifier['rs-report5'],
        variant: 'footnote',
      }}
      headerStyle={{ gap: 16 }}
      caption={{
        unit,
        item: <Text weight="bold" variant="small" text={organizationNames} />,
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={body}
        footer={footer}
        defaultBorderStyle={PDF_BORDER.THIN}
        tableWidth="100%"
        borderColor="secondary"
      />
    </ReportPage>
  );
};
